const auth = {
    // Provider Login
    providerSignIn: 'Provider Sign In',
    accessDashboard: 'Access your API management dashboard',
    email: 'Email',
    emailPlaceholder: 'you@company.com',
    invalidEmail: 'Please enter a valid email address',
    sendingCode: 'Sending code...',
    continueWithEmail: 'Continue with Email',
    orContinueWith: 'Or continue with',
    continueWithGoogle: 'Continue with Google',
    continueWithGithub: 'Continue with GitHub',
    continueWithApple: 'Continue with Apple',
    continueWithMicrosoft: 'Continue with Microsoft',
    continueWithProvider: 'Continue with {{provider}}',
    magicLinkTab: 'Magic link',
    passwordTab: 'Password',
    password: 'Password',
    passwordPlaceholder: 'Your password',
    otpCodeOptional: 'Security code (optional)',
    passwordSignIn: 'Sign in with password',
    usePassword: 'Use password',
    useSignInCode: 'Use sign-in code',
    passwordLoginDisabled: 'Password login is disabled for this provider.',
    customerPasswordLoginDisabled: 'Password login is disabled for this customer portal.',
    invalidCredentials: 'Invalid credentials provided.',
    passwordTooShort: 'Password must be at least 8 characters long.',
    forgotPassword: {
      title: 'Set or reset your password',
      description: 'Enter the email associated with your provider account and we will send you a link to set or reset your password.',
      submit: 'Send password link',
      submitting: 'Sending link...',
      success: 'If an account exists for that email, a link to set or reset your password has been sent.',
      backToLogin: 'Back to login',
      cta: 'Set or reset password',
      error: 'Unable to send password link. Please try again.',
    },
    resetPassword: {
      title: 'Choose a new password',
      description: 'Set a new password to finish resetting your account.',
      passwordLabel: 'New password',
      confirmPasswordLabel: 'Confirm new password',
      confirmPasswordPlaceholder: 'Confirm your new password',
      submit: 'Reset password',
      submitting: 'Resetting password...',
      success: 'Password reset successfully.',
      backToLogin: 'Back to login',
      invalidLink: 'Invalid or expired reset link.',
      invalidToken: 'Invalid or expired reset token.',
      passwordMismatch: 'Passwords do not match.',
      error: 'Unable to reset password. Please try again.',
    },
    passwordValidation: {
      minLength: 'Password must be at least {{count}} characters.',
      mixed: 'Password must include upper and lower case letters.',
      symbols: 'Password must include at least one symbol.',
      numbers: 'Password must include at least one number.',
    },
    passwordPolicy: {
      title: 'Password requirements',
      minLength: 'At least {{count}} characters.',
      requireNumbers: 'At least one number.',
      requireSymbols: 'At least one symbol.',
      requireMixedCase: 'Upper and lower case letters.',
      disallowPrevious: 'Cannot reuse your last {{count}} passwords.',
    },
    newToFlorentin: 'New here?',
    customerSignIn: 'Customer Sign In',
    errorSendingCode: 'Unable to send verification code. Please try again.',
    oauthSigningIn: 'Signing you in',
    oauthPending: 'Completing sign-in...',
    oauthPendingWithProvider: 'Completing sign-in with {{provider}}...',
    oauthAwaitingOnboarding: 'Almost done — choose how you plan to use Florentin to finish setup.',
    oauthErrorTitle: 'Sign-in failed',
    oauthDenied: 'Authorization denied. Please try again.',
    oauthMissingCode: 'Missing authorization code. Please try again.',
    oauthUnknownContext: 'We could not determine which portal to sign in.',
    oauthReturnToLogin: 'Back to {{context}} login',
    socialRoleModal: {
      title: 'Choose your account type',
      subtitle: 'Tell us how you plan to use Florentin so we can prep the right workspace before you continue.',
      lead: 'Choose the account type you’re creating',
      helper: 'We’ll include this with your social sign-in so onboarding can create the right workspace automatically.',
      individual: {
        title: "I'm signing up as an individual",
        description: 'Ideal for solo builders who need personal automations and analytics.',
      },
      team: {
        title: "I'm creating a team",
        description: 'Spin up a shared workspace, invite teammates, and manage seats together.',
        nameLabel: 'Team name',
        namePlaceholder: 'Acme Automation',
        sizeLabel: 'Team size (optional)',
        descriptionLabel: 'Team description (optional)',
        descriptionPlaceholder: 'Share a short note so teammates recognise the workspace.',
        descriptionHelper: 'We send this metadata to the backend to speed up onboarding.',
      },
      validation: {
        selectRole: 'Select how you plan to use Florentin before continuing.',
        teamNameRequired: 'Add a team name so we can route the workspace correctly.',
      },
      cta: 'Continue',
      ctaLoading: 'Redirecting…',
    },

    // Verify Page
    verifyEmail: 'Verify your email',
    codeSentTo: 'We sent a 6-digit code to {{email}}',
    didntReceiveCode: "Didn't receive the code?",
    resendIn: 'Resend in {{seconds}}s',
    resendCode: 'Resend code',
    useDifferentEmail: 'Use different email',
    testingNote: 'For testing, use code: 123456',
    incorrectCode: 'The code you entered is incorrect',
    emailVerification: {
      heading: 'Secure email verification',
      cardTitle: 'Email Verification',
      verifying: 'Verifying your email address...',
      alreadyVerifiedTitle: 'Email verified',
      successTitle: 'Email verified successfully',
      alreadyVerifiedBody: 'Your email address was verified successfully. You can continue to sign in.',
      successBody: 'Thanks! Your email address is verified.',
      errorTitle: "We couldn't verify your email",
      goToLogin: 'Go to login',
      returnToLogin: 'Return to login',
      home: 'Home',
      backToHome: 'Back to home',
    },
  } as const;

export default auth;
